import { render, staticRenderFns } from "./commissionSettings.vue?vue&type=template&id=322881b6&scoped=true"
import script from "./commissionSettings.vue?vue&type=script&lang=js"
export * from "./commissionSettings.vue?vue&type=script&lang=js"
import style0 from "./commissionSettings.vue?vue&type=style&index=0&id=322881b6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322881b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('322881b6')) {
      api.createRecord('322881b6', component.options)
    } else {
      api.reload('322881b6', component.options)
    }
    module.hot.accept("./commissionSettings.vue?vue&type=template&id=322881b6&scoped=true", function () {
      api.rerender('322881b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemManagement/commissionSettings/commissionSettings.vue"
export default component.exports